import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '@app/core/services/shared/shared.service';
import { UntypedFormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
    template: '',
    standalone: true
})
export class BaseComponent {
    public translate = inject(TranslateService);
    public sharedService = inject(SharedService);
    public formBuilder = inject(UntypedFormBuilder);
    public toastr = inject(ToastrService);

    public formGroup!: FormGroup;

    toastrError(message: string): void {
        this.toastr.error(message);
    }

    toastrSuccess(message: string): void {
        this.toastr.success(message);
    }
}
